<template>
    <q-list class="q-mb-md">
        <q-collapsible icon="fal fa-filter" v-model="open" @click="toggle" :label="getNameFilter">
            <div class="row gutter-sm" v-if="options">

                <div class="col-xs-12 col-sm-12" v-if="options.faq_categories">
                    <q-select filter autofocus-filter v-model="filters.faq_categories" chips :options="options.faq_categories" multiple :float-label="$t('categories')" clearable />
                </div>

                <div class="col-xs-12 col-sm-12" v-if="options.is_public && show_public_faq">
                    <q-select v-model="filters.is_public" chips :options="options.is_public" :float-label="$t('is_public')" clearable />
                </div>

                <div class="col-xs-12 col-sm-12" v-if="options.statuses">
                    <q-select chips v-model="filters.status" :options="options.statuses" :float-label="$t('status')" clearable />
                </div>

            </div>
            <div class="row gutter-sm justify-end q-mt-sm">
                <div class="col-xs-12 col-sm-3">
                    <q-btn color="negative" class="full-width" :label="$t('clear_filters')" icon="far fa-eraser" @click="clearFilter()"/>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <q-btn color="secondary" class="full-width" :label="$t('apply_filter_plural')" icon="far fa-filter" @click="requestFiltered()"/>
                </div>
            </div>
        </q-collapsible>
    </q-list>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
export default {
    props: ['options'],
    data() {
        return {
            open: false,
            filters: {
                faq_categories: [],
                is_public: null,
                status: null,
            }
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
			faqs_filters: 'admin_filters/faqs_filters',
            show_public_faq: 'params/login_show_public_faq',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getNameFilter() {
            if (Object.entries(this.filters).find((a) => a[1] && a[1].length > 0)) {
                return `${this.$t('filter')} <i class="far fa-exclamation-circle"></i>`
            } else return this.$t('filter')
        }
    },

    methods: {
        requestFiltered() {
            this.saveTrainingsFilters()
            this.$emit('requestFiltered')
            setTimeout(() => { this.toggle() }, 500)
        },

        clearFilter() {
            this.filters.faq_categories = []
            this.filters.is_public = null
            this.filters.status = null
            setTimeout(() => { this.toggle() }, 500)
        },

        toggle() {
            this.open = !this.open
        },

        saveTrainingsFilters() {
            this.$store.dispatch('admin_filters/SET_FAQS_FILTERS', { faqs_filters: this.filters })
        },

        clearStoredFilters() {
            this.$store.dispatch('admin_filters/SET_FAQS_FILTERS', { faqs_filters: {} })
        }
    },

    mounted () {
        if (this.faqs_filters && this.faqs_filters.faq_categories) {
            this.filters = this.faqs_filters
            setTimeout(() => { this.toggle() }, 500)
        }
    }
}
</script>

<style>

</style>
